import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import CSVWarning from '../FormFields/CSVWarning';

function RecipientWarning({ templateVariables }) {
  const { watch } = useFormContext();

  const templateId = watch('templateId');
  const recipients = watch('recipients');

  const warnings = useMemo(() => {
    if (!recipients?.length || !templateId) return;

    const recipientsMap = recipients.map(v => v.value);
    const result = {
      valid: true,
      errors: [],
      variablesWarnings: [],
      totalRows: 0,
    };

    recipientsMap.forEach(({ ...replacement }, index) => {
      let hasWarning = false;
      const warningResult = {
        row: index + 1,
        missingVariables: {},
      };

      const missingVariables = templateVariables.filter(e => !replacement[e]);
      if (missingVariables.length) {
        hasWarning = true;
        warningResult.missingVariables[templateId] = missingVariables;
      }

      if (hasWarning) result.variablesWarnings.push(warningResult);
    });

    result.totalRows += recipientsMap.length;
    result.valid = !result.errors.length;
    return result;
  }, [templateId, recipients]);

  return <CSVWarning data={warnings} label="Recipient" />;
}

export default RecipientWarning;
